import Slider from '../../common/Slider';
import { connect } from 'react-redux';
import { matrixBlur, matrixSliderChange } from './actions';
import { questionKey } from '../response/reducer';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const values = question.rows[ownProps.rowIndex].values;
  const value = Array.isArray(values) ? values[0] || '' : values;
  return { value };
};

const getChoice = (sliderValue, choices) => {
  const stepLength = 100/(choices.length - 1);
  const choiceIndex = Math.floor(sliderValue/stepLength);
  return choices[choiceIndex].name;
}

const updateSliderValue = (question, choice) => {
  document.getElementById(question).value = choice;
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e => {
    dispatch(matrixBlur(ownProps.rowIndex, ownProps.questionId)),
    dispatch(
      matrixSliderChange(
        getChoice(e, ownProps.choices),
        ownProps.rowIndex,
        ownProps.questionId
      )
    ),
    updateSliderValue(ownProps.name, getChoice(e, ownProps.choices))
    }
});

const MatrixSlider = connect(mapStateToProps, mapDispatchToProps)(Slider);

export default MatrixSlider;
